import styled from 'styled-components';

export const Content = styled.div`
 flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  font-family: 'Inter', sans-serif;
  overflow: hidden;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const SectionName = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  width: fit-content;
  padding-right: 1rem;
  margin-right: 1rem;
`

export const TabsContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 24px;

  background-color: #ffffff;
  border-radius: 999px;  /* arredondado só por fora */
  overflow: hidden;      /* garante o formato da pílula */
`




interface TabButtonProps {
  $active: boolean
}

export const TabButton = styled.button<TabButtonProps>`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 20px;
  background-color: ${({ $active }) =>
    $active ? '#E5F6FD' : '#ffffff'};
  color: ${({ $active }) => ($active ? '#0090D3' : '#6B7280')};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  cursor: pointer;

  /* borda padrão */
  border: 1px solid ${({ $active }) =>
    $active ? '#0090D3' : '#e5e7eb'};
  border-radius: 0; /* reto no meio */

  /* primeiro botão: arredonda só o lado de fora e NÃO desenha borda no meio */
  &:first-child {
    border-top-left-radius: 999px;
    border-bottom-left-radius: 999px;
    border-right-color: transparent;  /* evita linha dupla no meio */
  }

  /* segundo botão: arredonda o lado de fora e DESENHA a linha do meio */
  &:last-child {
    border-top-right-radius: 999px;
    border-bottom-right-radius: 999px;
    border-left-color: #e5e7eb;       /* sempre cinzinha no meio */
  }

  img {
    width: 16px;
    height: 16px;
    display: block;
  }
`



export const TabPlaceholder = styled.div`
  padding: 24px 0;
  color: #6b7280;
  font-size: 18px;

  h3 {
    margin-bottom: 8px;
    font-size: 23px;
    font-weight: 600;
    color: #111827;
  }
`
